import Home from "./routes/Home"
import About from "./routes/About"
import Service from "./routes/Service"
import Contact from "./routes/Contact"
import Booking from "./components/Booking"
import Gallery from "./routes/Gallery"
import Jobs from "./routes/Jobs"
import BookingPage from "./routes/Booking"
import NotFound from "./routes/NotFound"
import "./style.css";
import { Route, Routes } from 'react-router-dom';
import ScrollToTop from "./components/ScrollToTop";


import React from 'react' 
// run using 'npm run'
function App() {
  // established connection to Navbar and all other page through import
  // Routes is just another word for linking
  // path is the url to that page, it is in components/MenuItems.js
  // Routes-> Route will allow user to click on the corresponding button and go to that page
  return (
    <div className="App">
      <ScrollToTop />
      <Routes>
        <Route path="/" element={<Home/>}/>
        <Route path="/404" element={<NotFound/>}/>
        <Route path="/service" element={<Service/>}/>
        <Route path="/contact" element={<Contact/>}/>        
        <Route path="/gallery" element={<Gallery/>}/>
        <Route path="/booking" element={<BookingPage/>}/>
        <Route path="/jobs" element={<Jobs/>}/>
        <Route path="*" element={<NotFound/>}/>
      </Routes>
    </div>
  );

  /**/ 
}

export default App;
